import { useRef, useState, useEffect} from "react";
import { PhoneNumberUtil } from 'google-libphonenumber';
import libPhoneNumberPackage from "google-libphonenumber/package.json";

import classes from './ReactInternationalPhone.module.scss';
import 'react-international-phone/style.css';
import { PhoneInput, defaultCountries,parseCountry, PhoneInputRefType } from 'react-international-phone';
import type { PhoneInputProps } from "react-international-phone";


const phoneUtil = PhoneNumberUtil.getInstance();
type PhoneChange = NonNullable<PhoneInputProps["onChange"]>;

const allowedCountries = defaultCountries.filter((country) => {
        const { iso2 } = parseCountry(country);
        return !['ps'].includes(iso2);
    });

const ReactInternationalPhone = (props) => 
{
    const ref = useRef<PhoneInputRefType>(null);

    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneAriaInvalid, setPhoneAriaInvalid] = useState(false);
    const [countryIso2, setCountryIso2] = useState<string | undefined>();

    useEffect(() => {
        if(props.ariaDescribedBy !== ""){
            ref.current?.setAttribute('aria-describedby',String(props.ariaDescribedBy));
        }

        console.log(
            "google-libphonenumber:",
            libPhoneNumberPackage.version
        );
    },[])

    useEffect(() => {                
        if(props.reset){            
            setPhoneNumber('');           
        }
    },[props.reset]);

    useEffect(() => {
        if(props.selectedCountry){
            ref.current?.setCountry(props.selectedCountry) ; 
        }
        
    },[props.selectedCountry]);

    const countrySelectorStyleProps = {
        className : `${classes.countrySelectorContainer}`,
        buttonClassName: `${classes.countrySelectorButton}`,
        dropdownArrowClassName: `${classes.countrySelectorDropdownArrow}`,
        dropdownStyleProps: {
            className: `${classes.countrySelectorDropdownContainer}`,
            listItemDialCodeClassName: `${classes.listItemCountryDialCode}`,
            listItemCountryNameClassName: `${classes.listItemCountryName}`,
            listItemFlagClassName: `${classes.listItemFlag}`
        }       
    };
        
    const isPhoneValid = (phone: string) => {
        try {
          return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
        } catch (error) {
          return false;
        }
    };
   
    const phoneChange:PhoneChange = (phone, meta) => { 
                              
        var inputValue = meta.inputValue.replaceAll(" ","");
        
        // fire only when the country actually changes
        if (meta.country.iso2 !== countryIso2) {
            setCountryIso2(meta.country.iso2);
            props.countryChange(meta.country.iso2);
            return;           
        }
        
        setPhoneNumber(phone);
        const isPhoneNumValid = isPhoneValid(phone);
        if(isPhoneNumValid){
            const paredNumber  = phoneUtil.parseAndKeepRawInput(phone);
            setPhoneAriaInvalid(false);
            if(props.ariaDescribedBy !== ""){
                ref.current?.setAttribute('aria-describedby',String(props.ariaDescribedBy));
            }
            props.getPhoneNumber(`+${paredNumber.getCountryCode()}${paredNumber.getNationalNumber()}`,isPhoneNumValid, inputValue);
        }
        else{
            setPhoneAriaInvalid(true);
            if(props.ariaDescribedBy !== ""){
                ref.current?.removeAttribute("aria-describedby");
            }
            props.getPhoneNumber(phone,isPhoneNumValid,inputValue);          
        }            
    }

    const onPasteHandler = (event: React.ClipboardEvent<HTMLInputElement>) => {
        if(!props.pasteEnabled){
          event.preventDefault(); 
        }    
    }

    const onKeyPressHandler = (e:any) => {
        if (e.charCode === 13) {
          props.handleEnter();
        }
    }

    return( 
        <div
            onPaste={onPasteHandler}
            onKeyPress={onKeyPressHandler}          
            >           
            <PhoneInput    
                ref={ref}            
                defaultCountry="il"
                preferredCountries={["il","us"]}
                countries={allowedCountries}
                value={phoneNumber}
                onChange={phoneChange}                
                disableDialCodeAndPrefix = {true}
                className = {classes.phoneContainer}
                inputClassName = {classes.phoneInput}
                countrySelectorStyleProps={countrySelectorStyleProps} 
                disabled = {props.disabled} 
                inputProps = {{
                    id: `${props.id}`,
                    'aria-errormessage': `${props.ariaErrorMessage}`,
                    'aria-invalid': `${phoneAriaInvalid}`,
                    autoComplete: "off"                
                }}                                  
            />
        </div>
    );

};
export default ReactInternationalPhone;